module.exports = __webpack_public_path__ + "static/media/box.828be1b6.svg";